import * as yup from 'yup'
import i18n from '../../i18n'

export const combineSchema = yup.object({
  typeCombine: yup
    .string()
    .trim()
    .required(() => i18n.t('general.validator.empty')),
  labels: yup
    .array(
      yup.object({
        name: yup.string(),
        id: yup.string()
      })
    )
    .default([])
    .nullable()
})
